/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderNumber: NonNullable<unknown> }} Orders_Inspection_Review_AriaInputs */

const en_orders_inspection_review_aria = /** @type {(inputs: Orders_Inspection_Review_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inspection review for order ${i?.orderNumber}`)
};

const es_orders_inspection_review_aria = /** @type {(inputs: Orders_Inspection_Review_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revision de inspeccion para el pedido ${i?.orderNumber}`)
};

/**
* | output |
* | --- |
* | "Inspection review for order {orderNumber}" |
*
* @param {Orders_Inspection_Review_AriaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_inspection_review_aria = /** @type {((inputs: Orders_Inspection_Review_AriaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Inspection_Review_AriaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_inspection_review_aria(inputs)
	return es_orders_inspection_review_aria(inputs)
});